import { SorterResult } from 'antd/es/table/interface';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const toSorter = (sort: SorterResult<any> | undefined, columnKey: React.Key) => {
  return columnKey === sort?.columnKey ? { sortOrder: sort.order } : {};
};
